import { render, staticRenderFns } from "./LicenseVerified.vue?vue&type=template&id=1b81c06f&scoped=true&"
import script from "./LicenseVerified.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LicenseVerified.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LicenseVerified.vue?vue&type=style&index=0&id=1b81c06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81c06f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b81c06f')) {
      api.createRecord('1b81c06f', component.options)
    } else {
      api.reload('1b81c06f', component.options)
    }
    module.hot.accept("./LicenseVerified.vue?vue&type=template&id=1b81c06f&scoped=true&", function () {
      api.rerender('1b81c06f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LicenseVerified/LicenseVerified.vue"
export default component.exports